import SettingsList from "./SettingsList";

export default SettingsList